import React, { useEffect } from 'react';
import Backdrop from 'components/Backdrop';
import Button from 'components/Button';
import { IoClose } from "react-icons/io5";

import './index.css';

type PopupProps = {
    title?: string;
    primaryButtonText?: string;
    primaryButtonOnClick?: (arg?) => void;
    secondaryButtonText?: string;
    secondaryButtonOnClick?: () => void;
    thirdButtonText?: string; 
    thirdButtonOnClick?: () => void;
    manageExit?: (event: any) => void;
    question?: string;
    indexFilters,
    handleReview: (event: string) => void;
    innerRef?: React.RefObject<HTMLDivElement>;
}

function Popup({
    title,
    primaryButtonText,
    primaryButtonOnClick,
    secondaryButtonText,
    secondaryButtonOnClick,
    thirdButtonText,
    thirdButtonOnClick,
    manageExit,
    question,
    indexFilters,
    handleReview,
    innerRef
}: PopupProps) {

    return (
        <>
            <Backdrop />
            <div className='popupACT' ref={innerRef}>
                <div className='popupACT__header'>
                    <h1 className='popupACT__title'>{title}</h1>
                    <IoClose className='popupACT__closeIcon' onClick={()=>{manageExit(false)}} />
                </div>
                <div className='popupACT__contentContainer'>
                    <div className='popupACT__content1'>
                        <div>
                            There are <span className='popupACT__contentNumber'>{indexFilters['Unanswered']}</span> unanswered question(s).
                        </div>
                        <div className='popupACT__reviewButton' onClick={()=>handleReview('Unanswered')}>UNANSWERED REVIEW</div>
                    </div>
                    <div className='popupACT__content2'>
                        <div>There are <span className='popupACT__contentNumber'>{indexFilters['Flagged']}</span> question(s) flagged for review.</div>
                        <div className='popupACT__reviewButton2' onClick={()=>handleReview('Flagged')}>FLAGGED REVIEW</div>
                    </div> 
                    <div>{question}</div>
                </div>
                <div className='popupACT__buttonGroup'>
                    {primaryButtonText &&
                        <Button
                            className='popupACT__button'
                            onClick={primaryButtonOnClick}
                        >
                            {primaryButtonText}
                        </Button>
                    }
                    {secondaryButtonOnClick &&
                        <Button
                            className='popupACT__button'
                            onClick={secondaryButtonOnClick}
                            secondary
                        >
                            {secondaryButtonText}
                        </Button>
                    }
                    {thirdButtonOnClick &&
                        <Button
                            className='popupACT__button'
                            onClick={thirdButtonOnClick}
                            third
                        >
                            {thirdButtonText}
                        </Button>
                    }
                </div>
            </div>
        </>
    );
}

export default Popup;